import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedGame: null,
  isGameModalOpen: false,

  mobileMenuOpen: false,

  gamesDropdownOpen: false,

  isLoading: false,

  error: null,
};

const homeSlice = createSlice({
  name: "home",

  initialState,

  reducers: {
    setSelectedGame: (state, action) => {
      state.selectedGame = action.payload;
    },

    openGameModal: (state, action) => {
      state.selectedGame = action.payload;
      state.isGameModalOpen = true;

      document.body.style.overflow = "hidden";
    },

    closeGameModal: (state) => {
      state.selectedGame = null;
      state.isGameModalOpen = false;

      document.body.style.overflow = "";
    },

    toggleMobileMenu: (state) => {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },

    closeMobileMenu: (state) => {
      state.mobileMenuOpen = false;
    },

    toggleGamesDropdown: (state) => {
      state.gamesDropdownOpen = !state.gamesDropdownOpen;
    },

    closeGamesDropdown: (state) => {
      state.gamesDropdownOpen = false;
    },

    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setSelectedGame,
  openGameModal,
  closeGameModal,
  toggleMobileMenu,
  closeMobileMenu,
  toggleGamesDropdown,
  closeGamesDropdown,
  setLoading,
  setError,
} = homeSlice.actions;

export default homeSlice.reducer;